module.exports = __webpack_public_path__ + "static/media/large_photo.fd7a178a.jpg";